jQuery(function ($) {


    $(document).on('wpcf7submit', '.section-contact-info-form  form.wpcf7-form', function (e) {
        const status = e.originalEvent.detail.status;
        console.log('STATUS:', status);

        if (status !== 'mail_sent') {
            return;
        }

        // hide form
        const $form = $(this);
        $form.hide();

        // add class for flex
        const $wrapper = $form.closest('.flex');
        $wrapper.addClass('align-center');

        // show success block
        const $success = $form.closest('.wpcf7').siblings('.success-block');
        if ($success.length) $success.show();
    });


});